import React, { useEffect, useState } from 'react'
import '../styling/containerStyles.css';
import { getBase64 } from './Functions/imageCompress';
import ButtonComp from '../components/button'
import Button from '@material-ui/core/Button';
import { Grid } from "@material-ui/core";
import DialogCamera from './dialogCamera';
import profilePic from '../assets/images/avatar3.png'
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

interface ImageUploadPageProps {
    setIsOnfidoPage: any;
    membershipID: any;
    faceCompare: Function;
    getSelfieFile: Function;
    banner: any;
    faceLiveMessage?: any;

}
let imageChange = false;

export const ImageUploadPage: React.FC<ImageUploadPageProps> = (props: ImageUploadPageProps) => {

    const {
        setIsOnfidoPage, membershipID, faceCompare, getSelfieFile, banner, faceLiveMessage
    } = props;

    const [uploadImage, setUploadImage] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [imagesData, setImagesData] = useState([]);
    const [contractorImage, setContractorImage] = useState([]);

    useEffect(() => {
        // getSelfieFile()
    }, [])

    const dialogOpen = async (props: any, data: any) => {
        imageChange = true;
        setUploadImage(!uploadImage)
        if (data && data.base64) {
            const compImage = await getBase64(data.base64) as string;
            setContractorImage(data)
            setImageUrl(compImage)
            setImagesData(data)
            getSelfieFile(await getBase64(data.base64))
        }
    };

    const handleSubmitImage = async () => {
        await faceCompare();
    }

    return (
        <div className='homeWrap'>
            <div className='homeTop'>
                {/* <div className='homeTopInner'>
                        <img src={pidiliteBlueLogo} alt='Pidilite Blue Logo' className='pidiliteLogo'/>
                        <img src={saathiLogo} alt='Saathi Logo' className='saathiLogo'/>
                        <div className='productLogoWrap'>
                            <img src={feviSealLogo} alt='Product Logo' className='productLogo'/>
                        </div>
                    </div> */}
                <div className='homeTopBanner'>
                    <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner' />
                </div>
            </div>
            <div className='doc-upload-main'>
                <div className='buttonAndLabel'>
                    <Button className='goBack back-btn' ><ArrowBackIosIcon /></Button>
                    <Label content='Online KYC Verification' />
                </div>
                <br></br>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                <br></br>
                    <img style={{ width: 130, height: 130, borderRadius: "50%" }}
                        src={imageUrl && imageUrl ? imageUrl : profilePic}
                        alt="KYC Profile" />
                    <div className="selfie_btn_paytm2 button">
                        <Button
                            onClick={async (e) => {
                                (setUploadImage(true))
                            }}>Upload selfie</Button></div>

                    <input
                        type="file"
                        accept="image/png, image/jpeg"
                        name="contractorImage"
                        style={{ visibility: "hidden" }}
                        onChange={async (e) => {

                        }}
                    >
                    </input>
                    {
                        <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex', justifyContent: "center" }}>
                            {faceLiveMessage}
                        </p>
                    }
                </Grid>
                <DialogCamera
                    cameraProps={props}
                    openDialog={uploadImage}
                    updatestate={dialogOpen}
                    openWebcam={true}
                />
                <ButtonComp label={'PROCEED'}
                    name={'PROCEED'}
                    visible={true}
                    disabled={!imageUrl}
                    handleToUpdate={handleSubmitImage}
                />

            </div>
        </div>
    )
}
export default ImageUploadPage